import { createContext, useContext } from 'react'
import type { useTimezone } from 'src/modules/core/hooks/use-timezone'

export type DisplayTimezoneContextValue = ReturnType<typeof useTimezone>

export const DisplayTimezoneContext = createContext<DisplayTimezoneContextValue | null>(null)

export function useDisplayTimezone() {
  const ctx = useContext(DisplayTimezoneContext)
  if (!ctx) throw new Error('useDisplayTimezone must be used within DisplayTimezoneProvider')
  return ctx
}
